<template>
  <div class="code-block">
    <div class="code-block-header">
      <CncButton name="copy code" :leftIcon="{ name: 'ico_paper_2' }" size="small" type="ghost" @click="copyCode"/>
    </div>
    <pre><code v-html="highlightedCode" class="code-block__content"></code></pre>
  </div>
</template>

<script>
import Prism from 'prismjs'
// นำเข้า theme และ language ที่ต้องการ
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-markup'

export default {
  name: 'CodeBlock',
  props: {
    content: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'javascript'
    }
  },
  computed: {
    highlightedCode () {
      return Prism.highlight(
        this.content,
        Prism.languages[this.language],
        this.language
      )
    }
  },
  methods: {
    copyCode () {
      navigator.clipboard.writeText(this.content)
    }
  }
}
</script>

<style lang="scss">
.code-block {
  border: 1px solid rgba(0,0,0,0);
  border-radius: 20px;
  background-color: white;
  padding: 24px;
  box-shadow: 0px 0px 15px rgba(0,0,0,.15);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  flex-direction: column;

  .code-block-header {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
